import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { greys } from "@clockwise/web-commons/src/styles/color.styles";
import { size, weight, fontFamilySans } from "@clockwise/web-commons/src/styles/type.styles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";
export { signupBtn } from "@components/login-wrapper/LoginWrapper.styles";

const CONTENT_WIDTH = 950;

const container: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  flex: 1,
  height: "calc(100% - 80px)", // height minus top nav bar
  width: "100%",
  position: "absolute",
  bottom: 0,
  left: 0,
};

const paper: CSSProperties = {
  background: greys.white,
  borderRadius: 10,
  maxWidth: CONTENT_WIDTH,
  padding: 40,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  "@media (max-width: 800px)": {
    flexDirection: "column",
    maxWidth: "none",
    height: "100%",
    width: "100%",
    padding: 20,
  },
};

const loadingBar: CSSProperties = {
  backgroundColor: "transparent",
  position: "absolute",
  bottom: 0,
  width: "100%",
};

const header: CSSProperties = {
  fontSize: "28px !important",
  paddingBottom: "20px !important",
  "@media (max-width: 800px)": {
    fontSize: "26px !important",
  },
};

const buttonContainer: CSSProperties = {
  marginBottom: 15,
  padding: "10px 0 5px 0",
  width: 220,
  "@media (max-width: 800px)": {
    width: "100%",
  },
};

const column: CSSProperties = {
  display: "flex",
  flexDirection: "column",
};

const illustration: CSSProperties = {
  maxWidth: 400,
  "@media (max-width: 800px)": {
    width: "100%",
  },
};

const customerContainer: CSSProperties = {
  maxWidth: CONTENT_WIDTH,
  width: "100%",
  padding: "0 15px",
  "@media (max-width: 800px)": {
    display: "none",
  },
};

const customerRow: CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  "&:first-child": {
    "&:first-child": {
      paddingLeft: 0,
    },
  },
};

const customer: CSSProperties = {
  width: "100%",
  height: "100%",
  display: "block",
  paddingLeft: ".5rem",
  paddingRight: ".5rem",
  marginLeft: "3%",
  maxWidth: 130,
  minHeight: 19,
  minWidth: "auto",
  opacity: 0.21,
  webkitFilter: "grayscale(100%) brightness(0)",
  filter: "grayscale(100%) brightness(0)",
};

const customerNearlySquarish: CSSProperties = {
  ...customer,
  maxHeight: 32,
  width: "auto",
  maxWidth: "none",
};

const customerSlightlyWide: CSSProperties = {
  ...customer,
  maxHeight: 32,
  width: "auto",
  maxWidth: "none",
};

const customerPrettyWide: CSSProperties = {
  ...customer,
  maxHeight: 32,
  width: "auto",
  maxWidth: "none",
};

const customerVeryWide: CSSProperties = {
  ...customer,
  maxWidth: 130,
  height: "auto",
};

export const subhead: CSSProperties = {
  lineHeight: "25px",
  fontSize: 16,
  marginBottom: 20,
  color: greys.dark,
  fontFamily: fontFamilySans,
  maxWidth: 450,
};

export const customerText: CSSProperties = {
  fontSize: "1.125rem",
  color: greys.cloudyBlue,
  paddingTop: "1.5rem",
  margin: "1rem 0",
};

export const agreement: CSSProperties = {
  color: greys.slate,
  fontSize: size.sm,
  fontWeight: weight.std,
  marginTop: spacing.sm,
  fontFamily: fontFamilySans,
};

export const link: CSSProperties = {
  color: greys.dark,
  borderBottomWidth: 0,
};

export const styles = {
  container,
  paper,
  header,
  buttonContainer,
  loadingBar,
  column,
  illustration,
  customerContainer,
  customerRow,
  customerNearlySquarish,
  customerSlightlyWide,
  customerPrettyWide,
  customerVeryWide,
};
